import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'

Sentry.init({
  dsn: 'https://9a12a9fc43fa4fcc9360f555fbfbeab5@sentry.conlance.org/17',
  release: process.env.REVISION,
  integrations: [new Integrations.BrowserTracing()]
})

window.Sentry = Sentry
